import { default as DOMButtonOrA } from './DOMButtonOrA';

export default DOMButtonOrA;
